import axios from 'axios';

export default {
    getClinicInformation(cb, { Longitude, Latitude, dealerId, clientToken }) {
        axios
            .get('/api/Clinic', {
                params: {
                    Longitude,
                    Latitude
                },
                headers: {
                    Authorization: `Bearer ${clientToken}`,
                    Dealer: dealerId
                }
            })
            .then(response => response.data)
            .then(data => {
                cb(data);
            })
            .catch(err => cb(err.response));
    },
};
